<template>
      <v-container
        class="my-3"
        fluid
      >
        <v-layout column>
          <v-flex xs12>
            <v-card color="grey lighten-5" class="black--text">
              <v-card-title primary-title>
                <div class="headline">{{name}}</div>
              </v-card-title>
              <v-text-field
                readonly
                class="px-3"
                label="Client ID"
                v-model="clientId"  
              ></v-text-field>
              <v-text-field
               class="px-3"
                v-model="clientSecret"
                :append-icon="show ? 'visibility_off' : 'visibility'"
                :rules="[rules.required, rules.min]"
                :type="show ? 'text' : 'password'"
                readonly
                label="Client Secret"
                @click:append="show = !show"
              ></v-text-field>
              <v-card-actions>
                <v-btn flat color="deep-orange" @click="remove">Remove</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>        
        </v-layout>
      </v-container>
  
</template>

<script>
const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;

export default {
  name: "api-client",
  props: ["auth", "client"],
  data() {
    return {
      show: false,
      name: null,
      clientId: null,
      clientSecret: null,
      rules: {
        required: value => !!value || "Required.",
        min: v => v.length >= 8 || "Min 8 characters"
      }
    };
  },
  created() {
    this.name = this.client.name;
    this.clientId = this.client.clientId;
    this.clientSecret = this.client.clientSecret;
  },
  methods: {
    showHide() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    remove() {
      this.$http
        .delete(`${API_ENDPOINT}/apiClient/${this.client.clientId}`)
        .then(
          () => {
            this.$parent.$emit("api-client-update");
          },
          error => {
            console.error(`Error while removing object: ${error.statusText}`);
          }
        );
    }
  }
};
</script>

<style scoped>
.client input {
  width: 100%;
}

.client h5 {
  margin: 20px 0 10px;
}

.client-header h3 {
  margin-top: 0;
  color: #42b983;
}

.scrolling-wrapper {
  /* Make this scrollable when needed */
  overflow-x: auto;
  /* We don't want vertical scrolling */
  overflow-y: hidden;
  /* Make an auto-hiding scroller for the 3 people using a IE */
  -ms-overflow-style: -ms-autohiding-scrollbar;
  /* For WebKit implementations, provide inertia scrolling */
  -webkit-overflow-scrolling: touch;
  /* We don't want internal inline elements to wrap */
  white-space: nowrap;
  /* Remove the default scrollbar for WebKit implementations */
  &::-webkit-scrollbar {
    display: none;
  }
}

.button-error {
  color: #fff !important;
  background-color: #ff5252 !important;
  border-color: #ff5252 !important;
}
</style>
